var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"px-0 py-0 font-bold dark:text-white",attrs:{"large":"","items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }